import { DeepLinkHandler } from '@components/DeepLinkHandler/DeepLinkHandler.component';
import { SuspenseWithErrorBoundary } from '@components/ErrorBoundary/SuspenseWithErrorBoundary';
import DashboardLayout from '@components/Layout/DashboardLayout';
import IRISPaymentHistory from '@pages/IRISPaymentHistoryPage.component.tsx';
import { ROUTE_PATH } from '@shared/constants/route-path.enum';
import { lazy, ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import FourOhFour from './404.tsx';
import ProtectedRoute from './ProtectedRoute.tsx';

const ProtectedRouteWithSuspense = (props: { element: ReactElement }) => (
  <SuspenseWithErrorBoundary>
    <ProtectedRoute element={props.element} />
  </SuspenseWithErrorBoundary>
);

export const Routing = () => {
  const Home = lazy(() => import('@pages/HomePage.component'));
  const Correspondences = lazy(() => import('@pages/CorrespondencesPage.component'));
  const Contributions = lazy(() => import('@pages/ContributionsPage.component'));
  const Disability = lazy(() => import('@pages/disability/DisabilityPage.component'));
  const Certificates = lazy(() => import('@pages/CertificatesPage.component'));
  const Notifications = lazy(() => import('@pages/notifications/Notifications.component'));
  const InsuranceClearanceCertification = lazy(
    () => import('@pages/insuranceClearance/InsuranceClearanceCertification.component')
  );
  const Services = lazy(() => import('@pages/services/ServicesPage.component'));
  const Settings = lazy(() => import('@pages/settings/SettingsPage.component'));
  const Unauthorized = lazy(() => import('@pages/UnauthorizedPage.component'));
  const InsuranceHistory = lazy(() => import('@pages/InsuranceHistoryPage.component.tsx'));

  return (
    <>
      <DeepLinkHandler />
      <Routes>
        <Route path={ROUTE_PATH.ROOT} element={<DashboardLayout />}>
          <Route index element={<ProtectedRouteWithSuspense element={<Home />} />} />

          <Route path={ROUTE_PATH.NOTIFICATIONS} element={<ProtectedRouteWithSuspense element={<Notifications />} />} />

          <Route path={ROUTE_PATH.SERVICES} element={<ProtectedRouteWithSuspense element={<Services />} />} />
          <Route path={ROUTE_PATH.SETTINGS} element={<ProtectedRouteWithSuspense element={<Settings />} />} />

          <Route
            path={ROUTE_PATH.CORRESPONDENCES}
            element={<ProtectedRouteWithSuspense element={<Correspondences />} />}
          />

          <Route
            path={ROUTE_PATH.INSURED_HISTORY}
            element={<ProtectedRouteWithSuspense element={<InsuranceHistory />} />}
          />
          <Route path={ROUTE_PATH.NOTIFICATIONS} element={<ProtectedRouteWithSuspense element={<Notifications />} />} />

          <Route path={ROUTE_PATH.CONTRIBUTIONS} element={<ProtectedRouteWithSuspense element={<Contributions />} />} />

          <Route path={ROUTE_PATH.DISABILITY} element={<ProtectedRouteWithSuspense element={<Disability />} />} />

          <Route path={ROUTE_PATH.CERTIFICATES} element={<ProtectedRouteWithSuspense element={<Certificates />} />} />

          <Route
            path={ROUTE_PATH.INSURANCE_CLEARANCE_CERTIFICATION}
            element={<ProtectedRouteWithSuspense element={<InsuranceClearanceCertification />} />}
          />

          <Route
            path={ROUTE_PATH.IRIS_PAYMENT_HISTORY}
            element={<ProtectedRouteWithSuspense element={<IRISPaymentHistory />} />}
          />

          <Route path={ROUTE_PATH.UNAUTHORIZED} element={<Unauthorized />} />
          <Route path="*" element={<FourOhFour />} />

          <Route path={ROUTE_PATH.NOTIFICATIONS} element={<ProtectedRouteWithSuspense element={<Notifications />} />} />
        </Route>
      </Routes>
    </>
  );
};
